let runtimeSrc = null;
let threeSrc = null;
export const usesThree = (code) => /\bTHREE\./.test(code || '') && !/<script[^>]+src=[^>]*three/i.test(code || '');

export async function loadRuntime() {
  if (!runtimeSrc) runtimeSrc = await (await fetch('/titan-runtime.js')).text();
  if (!threeSrc) threeSrc = fetch('/vendor/three.min.js').then((r) => r.text()).catch(() => { threeSrc = null; return ''; });
  if (threeSrc instanceof Promise) threeSrc = await threeSrc;
  return runtimeSrc;
}

export function normalizeGame(code) {
  const c = (code || '').trim();
  if (/<html[\s>]/i.test(c) || /<!doctype/i.test(c)) return c;
  if (/<(canvas|script|body|div|style)[\s>]/i.test(c)) return `<!DOCTYPE html><html><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"></head><body style="margin:0;background:#000">${c}</body></html>`;
  return `<!DOCTYPE html><html><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"><style>html,body{margin:0;height:100%;background:#000;overflow:hidden}</style></head><body><script>\n${c}\n</script></body></html>`;
}

export function buildGameDoc(code, cfg, extraHead = '') {
  const html = normalizeGame(code);
  const inject = `<script>window.__TITAN_CFG=${JSON.stringify(cfg).replace(/</g, '\\u003c')};</script><script>${runtimeSrc || ''}</script>${usesThree(html) && threeSrc ? `<script>${threeSrc}</script>` : ''}${extraHead}`;
  if (/<head(\s[^>]*)?>/i.test(html)) return html.replace(/<head(\s[^>]*)?>/i, (m) => m + inject);
  return html.replace(/<html[^>]*>/i, (m) => m + '<head>' + inject + '</head>');
}

export const PLACEHOLDER_GAME = `<!DOCTYPE html><html><head><meta charset="utf-8"><meta name="titan-controls" content="tap"><style>html,body{margin:0;height:100%;background:#030712;color:#67e8f9;font-family:monospace;display:flex;align-items:center;justify-content:center;text-align:center}h1{font-size:28px;letter-spacing:6px;color:#c4b5fd;text-shadow:0 0 24px #8b5cf6}p{opacity:.7}</style></head><body><div><h1>FORGIA VUOTA</h1><p>Descrivi il tuo gioco a THE ARCHITECT<br>per generarlo qui.</p></div></body></html>`;
